import { render, staticRenderFns } from "./AlternateSelectDialog.vue?vue&type=template&id=06248a3c"
import script from "./AlternateSelectDialog.vue?vue&type=script&lang=js"
export * from "./AlternateSelectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports